import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

import ApiVersionConstants from "../constants/api-version-constants";
import { RequestedService } from "../models/RequestedService";

@Injectable({
  providedIn: "root",
})
export class RequestedServiceService {
  private baseUrl = `${environment.apiConfig.uri}/${ApiVersionConstants.V_2}/admin/requestedService`;
  private baseUrlAdmin = `${environment.apiConfig.uri}/${ApiVersionConstants.V_2}/admin`;

  constructor(private http: HttpClient) {}

  getFamCodes(): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrlAdmin}/famCodes`);
  }

  getRequestedServices(famCode: string): Observable<RequestedService[]> {
    return this.http.get<RequestedService[]>(`${this.baseUrl}?famCode=${famCode}`);
  }

  addServiceRequest(requestService: RequestedService) {
    return this.http.post(`${this.baseUrl}`, requestService);
  }

  deleteServiceRequest(requestService: RequestedService) {
    return this.http.post(`${this.baseUrl}/delete`, requestService);
  }
}
